<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              Filter:
              <b-form-checkbox-group
                v-model="selectedRegions"
                :options="regionsOptions"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                class="demo-inline-spacing"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-for="region in selectedRegions"
      :key="region.name"
      class="match-height"
    >
      <b-col>
        <regions-table
          :region="region"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import {
  BRow,
  BCol,
  BCard,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import RegionsTable from './RegionsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormCheckboxGroup,
    RegionsTable,
  },
  data() {
    return {
      selectedRegions: ['Stockholms län', 'Västra Götalands län', 'Skåne län'],
      regionsOptions: [
        { item: 'Stockholms län', name: 'Stockholms län' },
        { item: 'Västra Götalands län', name: 'Västra Götalands län' },
        { item: 'Skåne län', name: 'Skåne län' },
      ],
    }
  },
}
</script>

<style>

</style>
